export function formatarCategoria(categoria: string): string {
  const mapa: Record<string, string> = {
    ALUNO_TECNICO: 'Aluno Técnico',
    ALUNO_GRADUACAO: 'Aluno Graduação',
    ALUNO_POS: 'Aluno Pós-graduação',
    SERVIDOR: 'Servidor',
    DOCENTE: 'Docente',
    PROCURADOR: 'Procurador',
  };
  return mapa[categoria] || categoria;
}

export function formatarPerfil(perfil: string): string {
  const mapa: Record<string, string> = {
    INTEGRACAO_CANDIDATOS: 'Integração de Candidatos',
    INTEGRACAO_CANDIDATOS_COMPLETO: 'Integração Completa (Candidatos + Fotos)',
  };
  return mapa[perfil] || perfil;
}
